<template>
    <nav
        :class="{ active: navigating }"
        class="nibnut-sidenav"
        v-touch:swipe="swiped"
    >
        <ul class="nav">
            <router-link
                :to="{ name: 'home' }"
                v-slot="{ href, navigate }"
                custom
            >
                <li
                    :class="{ 'active': ($route.name === 'home') || ($route.name === 'ui-catalog') }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="home" size="1x" />
                        <span>{{ $root.translate("Dashboard") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                :to="{ name: 'property.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="sign" size="1x" />
                        <span>{{ $root.translate("Properties") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_beta_testing(profile, 'NEW_LISTS')"
                :to="{ name: 'person.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="address-book" size="1x" />
                        <span>{{ $root.translate("Contacts") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_beta_testing(profile, 'NEW_LISTS')"
                :to="{ name: 'outreach.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="bullhorn" size="1x" />
                        <span>{{ $root.translate("Outreach") }}</span>
                    </base-link>
                </li>
            </router-link>
            <!--
            <router-link
                :to="{ name: 'property.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="archive" size="1x" />
                        <span>{{ $root.translate("Files") }}</span>
                    </base-link>
                </li>
            </router-link>
            //-->
            <router-link
                :to="{ name: 'task.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="calendar" size="1x" />
                        <span>{{ $root.translate("Tasks") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_at_least_administrator"
                :to="{ name: 'user.list' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="users" size="1x" />
                        <span>{{ $root.translate("Users") }}</span>
                    </base-link>
                </li>
            </router-link>
            <router-link
                v-if="is_at_least_administrator"
                :to="{ name: 'settings' }"
                v-slot="{ href, navigate, isActive }"
                custom
            >
                <li
                    :class="{ 'active': isActive }"
                    class="nav-item"
                >
                    <base-link
                        :href="href"
                        @click.native="navigate($event); $emit('navigate', false)"
                    >
                        <open-icon glyph="cog" size="1x" />
                        <span>{{ $root.translate("Settings") }}</span>
                    </base-link>
                </li>
            </router-link>
            <li
                v-if="installable"
                class="nav-item"
            >
                <base-link
                    href="#"
                    @click.prevent="$emit('install')"
                >
                    <open-icon glyph="arrow-circle-down" size="1x" />
                    <span>{{ $root.translate("Install") }}</span>
                </base-link>
            </li>
        </ul>
        <div class="nibnut-sidenav-footer">
            <div v-if="!navigating">
                &copy;&nbsp;{{ current_year }}<br />
                v.{{ app_version }}
            </div>
            <div v-else>
                &copy;&nbsp;{{ current_year }}&nbsp;{{ setting("customer_name") }}<br />
                {{  $root.translate("App sprouted from a") }}&nbsp;<a href="https://nibnut.com"><base-image :src="nibnut_logo" alt="nibnut" /></a>&nbsp;&bull;&nbsp;v.{{ app_version }}
            </div>
        </div>
    </nav>
</template>

<script>
import { profile_utilities, misc_utilities, string_utilities } from "@/nibnut/mixins"

import { BaseImage, BaseLink, OpenIcon } from "@/nibnut/components"

import nibnut_logo from "@/assets/img/nibnut.png"

export default {
    mixins: [profile_utilities, misc_utilities, string_utilities],
    components: {
        BaseImage,
        BaseLink,
        OpenIcon
    },
    methods: {
        swiped (direction) {
            if((direction === "left") || (direction === "right")) this.$emit("navigate", (direction === "right"))
        }
    },
    computed: {
        nibnut_logo () {
            return nibnut_logo
        }
    },
    props: {
        navigating: {
            type: Boolean,
            required: true
        },
        installable: {
            type: Boolean,
            required: false
        }
    }
}
</script>
